import format from 'date-fns/format';
import React, { FC, memo } from 'react';
import SectionHeading from '../SectionHeading';
import {
  Container,
  DatePill,
  DateTime,
  Description,
  DescriptionCta,
  OfficeHourCard,
  OfficeHourRow,
  PillDate,
  PillWeekday,
  SubBlock,
  SubHeader,
  SubTitle,
  TimeRange,
} from './styles';

// Narrow prop shape (only the fields rendered here) so this presentational
// view can be fed either the live selector output or mocked preview data.
export interface PremiumResourcesViewProps {
  officeHours: ReadonlyArray<{
    id: string;
    startDatetime: Date;
    endDatetime: Date;
  }>;
}

const PremiumResourcesView: FC<PremiumResourcesViewProps> = ({
  officeHours,
}) => {
  const upcomingHours = officeHours.slice(0, 3);

  if (upcomingHours.length === 0) {
    return null;
  }

  return (
    <Container>
      <SectionHeading title="Catch up on Premium Resources" />

      <SubBlock>
        <SubHeader>
          <SubTitle>Upcoming office hours</SubTitle>
          <Description>
            Join an upcoming session to get guidance and inspiration.{' '}
            <DescriptionCta to="/office-hours">
              Reserve your spot now!
            </DescriptionCta>
          </Description>
        </SubHeader>
        <OfficeHourRow>
          {upcomingHours.map((hour) => (
            <OfficeHourCard key={hour.id} to={`/office-hours/${hour.id}`}>
              <DatePill>
                <PillWeekday>{format(hour.startDatetime, 'EEEE')}</PillWeekday>
              </DatePill>
              <DateTime>
                <PillDate>{format(hour.startDatetime, 'MMMM d')}</PillDate>
                <TimeRange>
                  {format(hour.startDatetime, 'h:mm a')} &#8212;{' '}
                  {format(hour.endDatetime, 'h:mm a')}
                </TimeRange>
              </DateTime>
            </OfficeHourCard>
          ))}
        </OfficeHourRow>
      </SubBlock>
    </Container>
  );
};

export default memo(PremiumResourcesView);
